import Icon from '../components/Icon.vue'

Icon.register({"pen-square":{"width":448,"height":512,"paths":[{"d":"M400 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H400C426.5 32 448 53.5 448 80V432C448 458.5 426.5 480 400 480zM238.1 177.9L102.4 313.6 96.1 370.7C95.3 378.3 101.7 384.8 109.4 384L166.5 377.7 302.2 242C304.5 239.7 304.5 235.9 302.2 233.5L246.7 178C244.2 175.6 240.4 175.6 238.1 177.9zM345 165.1L314.9 135C305.5 125.6 290.3 125.6 281 135L257.9 158.1C255.6 160.4 255.6 164.2 257.9 166.6L313.4 222.1C315.7 224.4 319.5 224.4 321.9 222.1L345 199C354.3 189.7 354.3 174.5 345 165.1z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/pen-square.js
// module id = pbFw
// module chunks = 0